import React, { useState } from 'react'
import { Textarea } from '@guillotinaweb/react-gmi'

const errorStyles = {
  fontSize: 12,
  textAlign: 'right',
  color: 'red',
  marginBottom: 10,
}

export function JSONEditor({ value, onChange }) {
  const [error, setError] = useState(false)

  const _onChange = (e, v = null) => {
    setError(e)
    onChange(e, v)
  }

  return (
    <>
      <Textarea
        placeholder="Query"
        value={null}
        defaultValue={
          typeof value === 'object' ? JSON.stringify(value, null, 4) : ''
        }
        className={error && 'is-danger'}
        onChange={(v) => {
          try {
            const value = JSON.parse(v)
            typeof value === 'object'
              ? _onChange(false, value)
              : _onChange(true)
          } catch (e) {
            _onChange(true)
          }
        }}
      />
      {error && <div style={errorStyles}>JSON inválido</div>}
    </>
  )
}
